import { Button } from '@zoom/react-ui'
import RoadRepair from '../icons/RoadRepair'

const Error = () => {
  return (
    <div className='flex h-screen flex-col items-center justify-center'>
      <RoadRepair />
      <p className='my-4 text-base font-semibold'>An error occurred</p>
      <Button
        onClick={() => {
          window.location.reload()
        }}
        type='secondary'
      >
        Refresh
      </Button>
    </div>
  )
}

export default Error
